export enum CustomerType {
	WhiteLabel = 'whiteLabel',
	Partner = 'partner',
	Zesty = 'Zesty',
	BO = 'BO',
}
